import React, { useEffect, useState } from "react";
import { AccessibilityClickableDiv } from "@skillz/accessibility";
import BottomSheet from "../../../ui/bottomSheet/BottomSheet";
import BottomSheetBody from "../../../ui/bottomSheet/bottomSheetBody/BottomSheetBody";
import BottomSheetHeader from "../../../ui/bottomSheet/bottomSheetHeader/BottomSheetHeader";
import Collapse from "../../../ui/collapse/Collapse";
import Icon from "../../../ui/icons/Icon";
import iconsList from "../../../ui/icons/iconsList";
import DiscoveryMobileFilterOption from "./discoveryMobileFilterOption/DiscoveryMobileFilterOption";
import classes from "./DiscoveryMobileFilterSheet.module.css";

const DiscoveryMobileFilterSheet = ({ filtersConfig, activeFiltersCount = 0, selections, lang, texts, onApplyFilters, onFreeSearch, onClear }) => {

    const [isSheetOpen, setIsSheetOpen] = useState(false);
    const [openFilterName, setOpenFilterName] = useState(filtersConfig?.[0]?.name);
    const [draftSelections, setDraftSelections] = useState(selections);

    useEffect(() => {
        if (openFilterName === undefined && filtersConfig?.[0]?.name)
            setOpenFilterName(filtersConfig[0].name);
        if (openFilterName && !filtersConfig?.some((filter) => filter.name === openFilterName))
            setOpenFilterName(filtersConfig?.[0]?.name);
    }, [filtersConfig, openFilterName]);

    useEffect(() => {
        if (!isSheetOpen)
            setDraftSelections(selections);
    }, [isSheetOpen, selections]);

    const handleSelectOption = (filter, option) => {
        setDraftSelections((currentSelections) => ({
            ...currentSelections,
            [filter.name]: option.id,
        }));
    };

    const openSheet = () => {
        setDraftSelections(selections);
        setOpenFilterName(filtersConfig?.[0]?.name);
        setIsSheetOpen(true);
    };

    const closeSheet = () => setIsSheetOpen(false);

    const applyFilters = () => {
        onApplyFilters(draftSelections);
    };

    const handleClearFilters = (e) => {
        e?.stopPropagation();
        onClear();
    };

    const handleClearDraftFilters = () => {
        setDraftSelections((currentSelections) => ({
            ...currentSelections,
            ...Object.fromEntries(filtersConfig.map((filter) => [filter.name, null])),
        }));
    };

    return (
        <div className={classes.MobileFilter}>
            <div className={classes.FreeSearchWrap}>
                <span className={classes.FreeSearchIconWrap} aria-hidden="true">
                    <Icon name={iconsList.discoverySearch} size="24px" color="#925FE2" />
                </span>
                <input type="search" placeholder={texts.discoveryFreeSearchPlaceholder} value={selections.free ?? ""} onChange={(e) => onFreeSearch(e.target.value)} aria-label={texts.discoveryFreeSearchPlaceholder} className={classes.FreeSearchInput} />
            </div>
            <div className={classes.FilterActions}>
                <AccessibilityClickableDiv className={classes.FilterButton} onClick={openSheet} role="button">
                    <Icon name={iconsList.filter} size="24px" />
                    <span>{texts.filter}</span>
                    {activeFiltersCount > 0 && <span className={classes.ActiveFiltersCount}>{activeFiltersCount}</span>}
                </AccessibilityClickableDiv>
                {!isSheetOpen && activeFiltersCount > 0 &&
                    <AccessibilityClickableDiv className={classes.ClearFilterButton} onClick={handleClearFilters} role="button">
                        <Icon name={iconsList.x} size="16px" color="#4B4B4B" />
                    </AccessibilityClickableDiv>
                }
            </div>
            <BottomSheet isOpen={isSheetOpen} close={closeSheet} actionText={texts.discoveryShowResults} onAction={applyFilters} dropClassSheet={classes.Sheet}>
                <BottomSheetHeader title={texts.discoveryMobileFilterTitle} onClose={closeSheet} closeIconName={iconsList.x} dropClass={classes.SheetHeader} dropClassTitle={classes.SheetTitle} dropClassClose={classes.CloseButton} />
                <BottomSheetBody dropClass={classes.SheetBody}>
                    <AccessibilityClickableDiv className={classes.ClearAll} onClick={handleClearDraftFilters} role="button">
                        {texts.discoveryClearAllFilters}
                    </AccessibilityClickableDiv>
                    <div className={classes.FilterList}>
                        {filtersConfig.map((filter) =>
                            <Collapse key={filter.name} title={filter.label?.[lang] ?? filter.label?.he} expanded={openFilterName === filter.name} onToggle={(isOpen) => setOpenFilterName(isOpen ? filter.name : null)} dropClass={classes.FilterCollapse} dropClassBtnWrapper={classes.FilterCollapseButton} dropClassContent={classes.FilterCollapseContent} listboxId={`discoveryMobileFilter-${filter.name}`} selector={'[role="option"]'}>
                                <div className={classes.OptionsGrid}>
                                    {filter.options?.map((option) =>
                                        <DiscoveryMobileFilterOption key={`${filter.name}-${option.id}`} option={option} lang={lang} isSelected={draftSelections?.[filter.name] === option.id} onClick={() => handleSelectOption(filter, option)} />
                                    )}
                                </div>
                            </Collapse>
                        )}
                    </div>
                </BottomSheetBody>
            </BottomSheet>
        </div>
    );
};

export default DiscoveryMobileFilterSheet;
